import { Component } from '@angular/core';
//import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'data-table-url',
    templateUrl: './url.component.html',
    styleUrls: ['./url.component.scss'],
    standalone: false
})
export class UrlComponent implements ICellRendererAngularComp {
    data: any;
    url: string;
    text: string;

    constructor() { }

    refresh(params: any): boolean {
        return true;
    }
    agInit(params: ICellRendererParams & { values: { url: (data: any) => string, text: (data: any) => string } }): void {
        this.data = params.data;

        this.url = params.values.url(this.data);
        this.text = params.values.text(this.data);
    }
}
